var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(_vm._s(_vm.address.name)+" "+_vm._s(_vm.address.street)+", "+_vm._s(_vm.address.postal_code)+" "+_vm._s(_vm.address.city))])}
var staticRenderFns = []

export { render, staticRenderFns }